import { Send } from "lucide-react";

export default function ChatInput({ value, onChange, onSubmit, loading, placeholderName }) {
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
            }}
            className="px-4 py-3 border-t border-[#E5DFD3] bg-white flex items-center gap-2"
        >
            <input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={
                    placeholderName ? `Type your question, ${placeholderName}…` : "Type your question…"
                }
                data-testid="chatbot-input"
                className="flex-1 rounded-full bg-[#F7F5F0] border border-[#E5DFD3] px-4 py-2.5 text-[14px] placeholder:text-[#8F8B83] focus:outline-none focus:border-[#0E2A47]"
            />
            <button
                type="submit"
                disabled={loading || !value.trim()}
                aria-label="Send"
                data-testid="chatbot-send"
                className="h-10 w-10 rounded-full bg-[#0E2A47] text-white grid place-items-center hover:bg-[#08182B] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
                <Send className="h-4 w-4" />
            </button>
        </form>
    );
}
